jQuery(document).foundation();

jQuery(document).ready(function($) {

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // layout
  $('.wp-block-columns').addClass('grid-x grid-margin-x cancel-last-margin');
  $('.wp-block-columns').wrap('<div><div class="grid-container"></div></div>');
  $('.wp-block-columns').filter('[class*="bg-"]').each(function() {
    for (var i=0; i<this.classList.length; i++) {
      if (this.classList[i].startsWith('bg-')) {
        $(this).parent().parent().addClass(this.classList[i]);
      }
    }
  });
  $('.wp-block-column').addClass('cell');
  $('.wp-block-columns.narrow').find('.cell:only-child').addClass('medium-10 medium-offset-1 large-8 large-offset-2');
  $('.wp-block-columns.narrow.two-columns').find('.cell:first-child').addClass('medium-5 medium-offset-1 large-4 large-offset-2');
  $('.wp-block-columns.narrow.two-columns').find('.cell:last-child').addClass('medium-5 large-4');
  $('.wp-block-columns').not('.narrow').find('.cell:only-child').addClass('medium-10 medium-offset-1');

  // hero animation
  var startDelay = 500;
  setTimeout(function() {
    $('.hero').addClass('faded-in');
  }, startDelay);
  // setTimeout(function() {
  //   console.log($('.hero lottie-player').get(0))
  //   $('.hero lottie-player').get(0).play();
  // }, 1500+startDelay); // the first number is for fading in (see .hero.faded in on scss and match here if changed)

  $('.hero').on("click", function() {
    $('html, body').animate({
      scrollTop: $('main').children().eq(1).offset().top,
    }, 500);  
  })

  // font shading - variable weight
  $('.font-shade').each(function() {
    var letters = $(this).html().split('');
    var newHtml = '';
    for (var i=0; i<letters.length; i++) {
      newHtml += '<span>'+letters[i]+'</span>';
    }
    $(this).html(newHtml);
    if ($(this).is('.font-shade-ltr')) {
      for (i=0; i<0.4*letters.length-1; i++) {
        $(this).children().eq(i).addClass('thick');
      }
      for (i=0; i<0.3*letters.length-1; i++) {
        $(this).children().eq(letters.length-1-i).addClass('thin');
      }
      $(this).children().not('.thick').not('.thin').addClass('normal');
    }
    if ($(this).is('.font-shade-rtl')) {
      for (i=0; i<0.4*letters.length-1; i++) {
        $(this).children().eq(i).addClass('thin');
      }
      for (i=0; i<0.3*letters.length-1; i++) {
        $(this).children().eq(letters.length-1-i).addClass('thick');
      }
      $(this).children().not('.thick').not('.thin').addClass('normal');
    }
  });
  // hide "date" from first line if Stay up to date
  // $('h2.stay-up-to-date > .font-shade:first-child').children('*:nth-last-child(1)').css('visibility','hidden').attr('aria-hidden','true');
  // $('h2.stay-up-to-date > .font-shade:first-child').children('*:nth-last-child(2)').css('visibility','hidden').attr('aria-hidden','true');
  // $('h2.stay-up-to-date > .font-shade:first-child').children('*:nth-last-child(3)').css('visibility','hidden').attr('aria-hidden','true');
  // $('h2.stay-up-to-date > .font-shade:first-child').children('*:nth-last-child(4)').css('visibility','hidden').attr('aria-hidden','true');
  // hide "Stay" from second line if Stay up to date
  // $('h2.stay-up-to-date > .font-shade:last-child').children('*:nth-child(1)').css('visibility','hidden').attr('aria-hidden','true');
  // $('h2.stay-up-to-date > .font-shade:last-child').children('*:nth-child(2)').css('visibility','hidden').attr('aria-hidden','true');
  // $('h2.stay-up-to-date > .font-shade:last-child').children('*:nth-child(3)').css('visibility','hidden').attr('aria-hidden','true');
  // $('h2.stay-up-to-date > .font-shade:last-child').children('*:nth-child(4)').css('visibility','hidden').attr('aria-hidden','true');

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})

// force video playing on window focus/alt-tab
function forceVideoPlay() {
  const video = document.querySelector('video');
  if (!document.hidden && video.paused) {
    video.play();
  }
}

document.addEventListener('visibilitychange', function() {
  forceVideoPlay();
});
window.onfocus = function(event) {
  forceVideoPlay();
}
